<form [formGroup]="form">
  <bepatient-question
    *ngFor="let question of questions"
    [question]="question"
    [form]="form"
    [ngClass]="question.customClasses.join(' ')"
  >
  </bepatient-question>
</form>
